var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    {
      staticClass: "asc__auth",
      style: "background-image: url(/static/" + _vm.bgFile + ")",
      attrs: { fluid: "" }
    },
    [
      _c(
        "b-row",
        [
          _c("b-col", {
            attrs: { cols: "12", sm: "2", md: "4", lg: "6", xl: "8" }
          }),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "asc__auth-right",
              attrs: { cols: "12", sm: "10", md: "8", lg: "6", xl: "4" }
            },
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("figure", { staticClass: "figure" }, [
                  _c("img", {
                    staticClass: "figure-img img-fluid",
                    attrs: {
                      src: _vm.logo.login,
                      width: "200",
                      alt: _vm.title.siteName
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "m-auto", attrs: { cols: "9" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "asc__auth-form",
                              attrs: { cols: "12" }
                            },
                            [_c("router-view")],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "asc__auth-idea", attrs: { cols: "12" } },
                    [
                      _c("figure", { staticClass: "figure" }, [
                        _c("img", {
                          staticClass: "figure-img img-fluid ideaLogo",
                          attrs: {
                            src: _vm.logo.idea,
                            alt: _vm.title.selfService
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "asc__auth-idea-verno" }, [
                        _c("span", [_vm._v("V")]),
                        _vm._v(" " + _vm._s(_vm.system.version))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "asc__auth-idea-copyright" }, [
                        _vm._v(_vm._s(_vm.system.copyright))
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c2651e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c2651e5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Auth/index.vue
// module id = null
// module chunks = 